<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/store/app';
// import { useVuelidate } from '@vuelidate/core';
// import * as validators from '@vuelidate/validators';
import { useI18n } from 'vue-i18n';
import Swal from 'sweetalert2';
import { MAX_FILE_BYTES, MAX_FILE_MB } from '@/helpers/Limits';
import fileToBase64 from '@/helpers/FileToBase64';
// import { useRoute } from 'vue-router';

// Composables
// import useItems from '@/composables/useItems';
// import useValidationErrors from '@/composables/useValidationErrors';
// import useErrorMessages from '@/composables/useErrorMessages';

// Router
// const route = useRoute();

// const paramID = route.params.id;

const { t } = useI18n();

const {
  loading,
} = storeToRefs(useAppStore());

const { setDocumentos } = useAppStore();

const rulesFile = {
  required: (nombre: string) => (value: FileList | null) => (value && value.length > 0) || t('$vuetify.validations.required', { field: t(`$vuetify.datosPasantia.${nombre}`).toLowerCase() }),
  requiredValidFile: (value: FileList | null) => {
    if (value && value.length > 0) {
      const extension = value[0].name.split('.').pop()?.toLowerCase();
      if (extension === 'pdf' || extension === 'docx') {
        return true;
      }
    }
    return t('$vuetify.validations.filetype');
  },
  requiredValidFileWord: (value: FileList | null) => {
    if (value && value.length > 0) {
      const extension = value[0].name.split('.').pop()?.toLowerCase();
      if (extension === 'docx' || extension === 'pdf') {
        return true;
      }
    }
    return t('$vuetify.validations.filetypeOnly', { extension: '.DOCX / .PDF' });
  },
  rulesFiles: (value: any) => !value || !value.length || value[0].size < MAX_FILE_BYTES || t('$vuetify.validations.fileweight', { mb: MAX_FILE_MB }),
};

const formFile = ref();

async function onFileInput(e: Event, name: string) {
  const [file] = (e.target as HTMLInputElement).files!;
  const extension = file.name.split('.').pop()?.toLowerCase() || '';

  // Se descarta antes de convertir: un archivo invalido no debe ocupar el
  // store ni pagar el costo del base64, y si quedara guardado se enviaria
  // aunque las reglas del formulario lo hayan rechazado en pantalla.
  if (file.size >= MAX_FILE_BYTES || !['pdf', 'docx'].includes(extension)) {
    setDocumentos(name, '', '');
    return;
  }

  try {
    setDocumentos(name, await fileToBase64(file), extension);
  } catch {
    setDocumentos(name, '', '');
    Swal.fire({ text: t('$vuetify.errores.lecturaArchivo'), icon: 'error' });
  }
}

async function submitForm() {
  const { valid }: { valid: boolean } = await formFile.value.validate();

  // const check = await v$.value.$validate();
  if (valid) {
    return true;
  }
  return false;
}

defineExpose({
  submitForm,
});

</script>
<template>
  <v-form @submit.prevent="" ref="formFile" :disabled="loading">
    <v-container class="pa-0">
      <v-row no-gutters>
        <v-alert
          variant="outlined"
          :title="`${$t('$vuetify.adjuntarDocumento')}:`"
          border="start"
          color="grey-darken-1"
        >
          <p>{{ $t('$vuetify.pregMotivacion') }}<br />
            {{ $t('$vuetify.pregTrabajar') }}</p>
        </v-alert>
      </v-row>
      <v-row no-gutters>
        <v-col
          cols="12"
        >
          <v-sheet class="ma-2">
            <FileComponent
              :label="$t('$vuetify.datosPasantia.motivacion')"
              :hint="$t('$vuetify.filetypeOnly', { extension: '.DOCX / .PDF' })"
              required="required"
              @input="onFileInput($event, 'motivacion')"
              :rules="[rulesFile.required('motivacion'), rulesFile.requiredValidFileWord, rulesFile.rulesFiles]"
              accept=".docx, .pdf"
            />
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<style scoped>

</style>
